import { render, staticRenderFns } from "./HubAccordion.vue?vue&type=template&id=6915c2ea&scoped=true&"
import script from "./HubAccordion.vue?vue&type=script&lang=js&"
export * from "./HubAccordion.vue?vue&type=script&lang=js&"
import style0 from "./HubAccordion.vue?vue&type=style&index=0&id=6915c2ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6915c2ea",
  null
  
)

export default component.exports